import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MessageCircleIcon, MessageSquareIcon, PhoneIcon, XIcon } from 'lucide-react';
import { business } from '../data/site';
export function ChatWidget() {
  const [open, setOpen] = useState(false);
  return (
    // 1Dash.Pro chat widget slot — replace contents with the live widget embed
    <div id="onedash-chat-widget" data-embed-provider="1dash-pro" className="fixed bottom-[76px] right-4 z-50 lg:bottom-6 lg:right-6" data-id="element-36" data-mp="2rncmnxop61sm">
      <AnimatePresence data-id="element-37" data-mp="31fs48tw30ocz">
        {open && <motion.div initial={{
          opacity: 0,
          y: 8,
          scale: 0.96
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 8,
          scale: 0.96
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} style={{
          transformOrigin: 'bottom right'
        }} className="absolute bottom-[72px] right-0 w-[min(320px,calc(100vw-2rem))] rounded-xl bg-white p-5 shadow-[0_20px_50px_-12px_rgba(7,27,71,0.4)]" role="dialog" aria-label="Chat with Soundside Marine" data-id="element-38" data-mp="31h39ky56e467">
            <p className="display text-2xl font-bold text-navy" data-id="element-39" data-mp="25j7dpsiwtsr4">Questions? We’re here.</p>
            <p className="mt-1 text-sm text-ink-muted" data-id="element-40" data-mp="2aik60ssjvs13">Reach Michael and the shop directly.</p>
            <div className="mt-4 grid gap-2" data-id="element-41" data-mp="2faaip5eymrvo">
              <a href={business.sms} className="flex min-h-[48px] items-center justify-center gap-2 rounded-md bg-navy font-semibold text-white hover:bg-navy-600" data-id="element-42" data-mp="2fb3fbdk7g103">
                <MessageSquareIcon className="h-4 w-4" aria-hidden="true" data-id="element-43" data-mp="2o9p43qg9sc9b" />
                Text {business.phone}
              </a>
              <a href={business.tel} className="flex min-h-[48px] items-center justify-center gap-2 rounded-md border border-navy/20 font-semibold text-navy hover:border-navy" data-id="element-44" data-mp="2tacvid8euv42">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-45" data-mp="ywu3fix5g4q5" />
                Call the shop
              </a>
            </div>
            <p className="mt-3 text-xs text-ink-soft" data-id="element-46" data-mp="13wpw4m0ec9qe">Connected to 1Dash.Pro</p>
          </motion.div>}
      </AnimatePresence>
      <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-label={open ? 'Close chat' : 'Open chat'} className="flex h-14 w-14 items-center justify-center rounded-full bg-water text-navy-950 shadow-[0_10px_30px_-8px_rgba(7,27,71,0.5)] transition-colors duration-150 hover:bg-water-300 active:scale-95" data-id="element-47" data-mp="rslzfvrcljlt">
        {open ? <XIcon className="h-6 w-6" data-id="element-48" data-mp="1ar6nfexy08v8" /> : <MessageCircleIcon className="h-6 w-6" data-id="element-49" data-mp="1aq58gzdt3288" />}
      </button>
    </div>
  );
}